import { Typography } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const TextLine = ({
	orderInfoLabel,
	orderValueLabel,
}: {
	orderInfoLabel: string;
	orderValueLabel: string;
}) => (
	<Typography variant="bodySubText" color={'grey.300'} mb={'10px'} component={'p'}>
		{orderInfoLabel}

		<Typography
			variant="bodySubText"
			color={'grey.500'}
			fontWeight={OpenSansFontWeights.semibold}
			ml={'5px'}
		>
			{orderValueLabel}
		</Typography>
	</Typography>
);
